import { helper } from '@ember/component/helper';
import moment from 'moment-timezone';
import { isEmpty } from '@ember/utils';
import { Grouping } from 'cio/utils/metrics/resolution';

export function wrapAsHighchartsDataPoints([values, timeRange, grouping]: [
  number[],
  { start: moment.Moment; end: moment.Moment },
  Grouping,
]) {
  if (isEmpty(values) || isEmpty(timeRange)) {
    return [];
  }

  let utcRange = {
    start: moment.tz(`${timeRange.start.format('YYYY-MM-DD')} 00:00:00`, 'Etc/UTC'),
    end: moment.tz(`${timeRange.end.format('YYYY-MM-DD')} 00:00:00`, 'Etc/UTC'),
  };

  let startTimestamp = utcRange.start.unix();

  let timestamps: number[] = [];

  if (grouping === Grouping.Daily) {
    timestamps = [...new Array(utcRange.end.diff(utcRange.start, 'days') + 1)].map(
      (_, i) => (startTimestamp + i * 24 * 60 * 60) * 1000,
    );
  } else if (grouping === Grouping.Weekly) {
    timestamps = [...new Array(utcRange.end.diff(utcRange.start, 'weeks') + 1)].map(
      (_, i) => (startTimestamp + i * 24 * 60 * 60 * 7) * 1000,
    );
  } else if (grouping === Grouping.Monthly) {
    timestamps = [...new Array(values.length)].map(
      (_, i) => moment(utcRange.start).startOf('month').add(i, 'months').unix() * 1000,
    );
  }

  if (timestamps.length !== values.length) {
    return [];
  }

  return timestamps.map((timestamp, i) => ({
    x: timestamp,
    y: values[i],
  }));
}

export default helper(wrapAsHighchartsDataPoints);
